import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import Dialog from '../../../../atoms/feedback/Dialog'
import { FlexColumn } from '../../../../atoms/layout/Flex'
import FormItem from '../../../../molecules/inputs/FormItem'
import { VisitorRegistrationFormSubcontractorFields } from '../../../../../types/Company'
import TextField from '../../../../atoms/inputs/TextField'
import PostalCodeField from '../../../../molecules/inputs/PostalCodeField'
import Button from '../../../../atoms/inputs/Button'
import { CompanyActions } from '../../../../../store/company'
import useValidationRule from '../../../../../hooks/useValidationRule'
import { useVisitorRegistrationFormSubcontractorEditDialog } from '../../../../../hooks/useDialog'

export default function VisitorRegistrationFormSubcontractorEditDialog() {
  const { state, close } = useVisitorRegistrationFormSubcontractorEditDialog()
  const validationRule = useValidationRule()
  const form = useForm<VisitorRegistrationFormSubcontractorFields>({
    resolver: yupResolver(validationRule.visitorRegistrationFormSubcontractor),
    defaultValues: state?.subcontractor,
  })
  const { errors } = form.formState
  const dispatch = useDispatch()

  const handleUpdate = useCallback(
    (fields: VisitorRegistrationFormSubcontractorFields) => {
      if (state) {
        dispatch(
          CompanyActions.updateVisitorRegistrationFormSubcontractor({ subcontractorId: state.subcontractor.id, fields })
        )
      }
    },
    [dispatch, state]
  )

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="下請け情報の編集"
      actions={<Button type="submit">更新</Button>}
      onSubmit={form.handleSubmit(handleUpdate)}
    >
      <FlexColumn>
        <FormItem label="事業者名" required>
          <TextField register={form.register('name')} error={errors.name?.message} />
        </FormItem>
        <FormItem label="事業者名かな" required>
          <TextField register={form.register('kana')} error={errors.kana?.message} />
        </FormItem>
        <FormItem label="代表者氏名" required>
          <TextField register={form.register('representativeName')} error={errors.representativeName?.message} />
        </FormItem>
        <FormItem label="代表者氏名かな" required>
          <TextField register={form.register('representativeKana')} error={errors.representativeKana?.message} />
        </FormItem>
        <FormItem label="郵便番号" required>
          <PostalCodeField
            getValues={form.getValues}
            register={form.register('zipCode')}
            onSearchAddress={(address) => form.setValue('address', address)}
            error={errors.zipCode}
          />
        </FormItem>
        <FormItem label="住所" required>
          <TextField register={form.register('address')} error={errors.address?.message} />
        </FormItem>
        <FormItem label="電話番号" required>
          <TextField register={form.register('phoneNumber')} error={errors.phoneNumber?.message} />
        </FormItem>
      </FlexColumn>
    </Dialog>
  )
}
